module.exports = __webpack_public_path__ + "static/ton-9f0a0f0f3f7971e49df37a8a82bd0408.jpg";